import {fabric} from 'fabric';
import {renderIcon} from '~/common/canvas/renderIcon';
import {toastAlert} from '~library/atoms/Toast';
import {AlertLineIcon} from '~library/svg/AlertLineIcon';
import DeleteIcon from '~library/svg/icons/DeleteIcon.svg';
import {white} from '~libSass/base/_exports.sass';
import {
  canvasAddTextBordersAndIcons,
  canvasRemoveTextBordersAndIcons,
} from '../customs/text_border';

export const removeControl = ({offsetX} = {}) => {
  const removeObject = (eventData, transform) => {
    if (transform.action === 'drag') {
      // Prevent drag action from triggering the remove control
      return;
    }
    const {canvas} = transform.target;
    canvasRemoveTextBordersAndIcons(canvas);
    const allObjects = canvas.getObjects();
    const allActiveObjects = canvas.getActiveObjects();
    const rectObject = allObjects?.find((rectObj) => rectObj.type === 'rect');

    const filterTextBoxes = (arr = []) => arr?.filter((textObj) => textObj?.type === 'textbox');

    const activePicture = allActiveObjects?.find(
      (picObj) => picObj.type !== 'textbox' && picObj.type !== 'rect'
    );
    const texts = filterTextBoxes(allObjects);
    const textObjectsToBeRemoved = filterTextBoxes(allActiveObjects);
    const isUyoSticker = allActiveObjects[0]?.id?.indexOf('uyo_sticker') > -1;
    const isSticker =
      allActiveObjects[0]?.originalUrl?.indexOf('sticker_image') > -1 || isUyoSticker;

    if (isSticker || texts.length - textObjectsToBeRemoved.length >= 1) {
      const callback = () => {
        allActiveObjects?.map((textObj) => canvas.remove(textObj));
        canvas.discardActiveObject();
        canvas.renderAll();
      };
      if (activePicture) {
        const originalActivePicture = activePicture._originalObject;
        if (originalActivePicture?.variant === 'logo' && originalActivePicture?.src) {
          fabric.UYOImage.fromURL(originalActivePicture.src, (img) => {
            img.set({
              variant: 'logo',
              id: originalActivePicture.id,
              selectable: false,
              hasControls: false,
              // biome-ignore lint/style/useNamingConvention: allow underscore
              _originalObject: originalActivePicture,
              ...originalActivePicture,
            });
            if (rectObject) canvas.remove(rectObject);
            canvas.insertAt(img, canvas.getObjects().length);
            canvas.renderAll();
            canvas.fire('object:modified');
            callback();
          });
        } else {
          rectObject?.set({fill: 'rgb(128,128,128,0.5)', type: 'uYOImage'});
          canvas.renderAll();
          canvas.fire('object:modified');
          callback();
        }
      } else {
        callback();
      }
    } else {
      toastAlert('Must have at least 1 text box', {
        type: 'error',
        icon: <AlertLineIcon ratio={0.65} />,
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    canvasAddTextBordersAndIcons(canvas);
  };

  const padding = 9;

  return new fabric.Control({
    x: 0,
    y: -0.5,
    offsetX: offsetX ?? -22,
    offsetY: -16 - padding,
    cursorStyle: 'pointer',
    mouseUpHandler: removeObject,
    render: renderIcon({icon: DeleteIcon, padding, fillStyle: white}),
    cornerSize: 16,
    touchSizeX: 32,
    touchSizeY: 32,
    sizeX: 30,
    sizeY: 30,
  });
};
